import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { OnFieldChanged } from '@ordersnproducts/modules/shared/modules/configurable-form/models/on-field-changed';
import * as moment from 'moment';
import { OneClickPreviewField } from '../../util/constants/preview-fields';

@Injectable()
export class OneClickSetTimepickerDateFromDatepickerCommand implements OnFieldChanged {
  onFieldChanged(value: any, formGroup: UntypedFormGroup): void {
    const date = moment(value);

    const timeControl = formGroup.get(OneClickPreviewField.Time);
    if (timeControl === null || timeControl.value === undefined) {
      return;
    }

    const hours = timeControl.value.hours();
    const minutes = timeControl.value.minutes();

    date.hours(hours).minutes(minutes);
    timeControl.setValue(date);
  }
}
